{
  "title": "Benchmarking Hangars",
  "buttons": {
    "stack": "Stack"
  },
  "resultGrid": {
    "columns": {
      "hangar": "Hangar",
      "progress": "Progress",
      "variants": "# Variants",
      "placed": "# Placed",
      "duration": "Duration",
      "utilization": "Utilization",
      "topUtilizations": "Top 4 Utilizations",
      "viewResults": "View Results"
    }
  }
}
